import { Spin } from 'antd';
import React from 'react';

const Loader: React.FC = React.forwardRef<
    HTMLDivElement, {}
>((props, ref) => {
    return (
      // <div ref={ref} className="preloader">
      //   <div className="background" data-background="main-background"></div>
      //   <div className="loader">
      //     <div></div>
      //   </div>
      // </div>
      <div className='w-full my-8 text-center'>
        <Spin size="large" />
      </div>
    );
});

export default Loader;
